var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-env browser */
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import { ErrorBoundary } from 'bernie-view';
import { Footer } from '@gc/global-components';
import { PlatformContext } from 'src/common/stores/contexts/platformContext';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { withLocalization } from '@shared-ui/localization-context';
import { OneKeyOnboardingWrapper } from '@shared-ui/retail-loyalty-one-key-onboarding';
import { MultiContextProvider, SearchCriteriaContext } from 'stores/contexts';
import { AnimatedProgressIndicator } from 'components/common/animated-progress-indicator';
import { Header } from 'components/common/header/header';
import { Notification } from 'components/common/notification';
import { MesoScripts } from 'components/meso/internals/meso-scripts';
import { SimpleLazyLoadWrapper } from '../../common/lazy/simple-lazy-load-wrapper';
import { BodyRegion } from './body-region';
const MemoizedFooter = React.memo(Footer);
const MemoizedHeader = React.memo(Header);
/**
 * MasterPage - stateless component for defining a reusable page structure with specific regions of content
 *
 * @param this.props {object} - the standard this.props object passed by React
 * @returns {string} - populated HTML of all applicable regions and wrapped in a div
 */
// @ts-ignore
let MasterPage = class MasterPage extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.analytics && this.props.route && this.props.route.routeData) {
      const routeData = this.props.route.routeData;
      this.props.analytics.setPageNamespace(routeData.rfrrNamespace || '');
      // nested the above if statement instead of appending to outer ones so we can start handling other routeData here
      if (this.props.page && !this.props.page.pageName) {
        this.props.page.pageName = routeData.pageName || 'page.unknown';
      }
    }
    this.setPageTitle = this.setPageTitle.bind(this);
  }
  componentDidMount() {
    this.setPageTitle(this.props.page && this.props.page.title);
  }
  componentWillUpdate(nextProps) {
    this.setPageTitle(nextProps.page && nextProps.page.title);
  }
  setPageTitle(title) {
    document.title = title || this.props.l10n.formatText('common.defaultPageTitle');
  }
  render() {
    const {
      context,
      'data-stid': dataStid,
      searchCriteria,
      pageHeader,
      templateContent,
      inlineMargin
    } = this.props;
    const contextPairs = [{
      context: PlatformContext,
      value: context
    }, {
      context: SearchCriteriaContext,
      value: searchCriteria
    }];
    return React.createElement(MultiContextProvider, {
      contextPairs: contextPairs
    }, React.createElement(ErrorBoundary, {
      label: "lodging.masterPage.renderToNodeStreamTest"
    }, React.createElement(Experiment, {
      name: "PWA_RENDER_TO_NODE_STREAM"
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    }))), React.createElement("div", {
      "data-stid": dataStid
    }, React.createElement(Experiment, {
      name: "Lodging_Shopping_PWA_EGTNL_AA_Test"
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    })), React.createElement(Experiment, {
      name: "vrbex_lodging_search_results_reduced_property_listings_feature_toggle"
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    })), React.createElement(ErrorBoundary, {
      label: "lodging.masterPage.header"
    }, React.createElement(MemoizedHeader, null)), React.createElement(ErrorBoundary, {
      label: "onekey.onboarding.shopping-pwa"
    }, React.createElement(OneKeyOnboardingWrapper, null)), React.createElement("main", null, React.createElement(BodyRegion, {
      templateContent: templateContent,
      pageHeader: pageHeader,
      inlineMargin: inlineMargin
    })), React.createElement(ErrorBoundary, {
      label: "lodging.masterPage.footer"
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(MemoizedFooter, {
      skipSsr: true
    }))), React.createElement(AnimatedProgressIndicator, null), React.createElement(Notification, null)), React.createElement(ErrorBoundary, {
      label: "meso.scripts.errorboundary"
    }, React.createElement(MesoScripts, null)));
  }
};
MasterPage.defaultProps = {
  l10n: null,
  templateContent: null
};
MasterPage = __decorate([withRouter
// @ts-ignore
, withLocalization, inject('analytics', 'context', 'experiment', 'page', 'multiItem', 'searchCriteria')], MasterPage);
export { MasterPage };